import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "mb-6 mt-4 px-4 ms-0 ms-md-6 me-8" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "fad fa-calendar-alt fa-4x" }, null, -1)
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 0,
  class: "nav nav-pills d-flex flex-nowrap hover-scroll-x py-2"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "fs-7 text-white fw-bold" }
const _hoisted_7 = { class: "fs-6 fw-boldest" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  class: "fs-3 fw-bolder text-dark text-hover-primary",
  style: {"text-overflow":"ellipsis","white-space":"nowrap","overflow":"hidden"}
}
const _hoisted_10 = { class: "fs-6 mb-0 d-none d-md-flex" }
const _hoisted_11 = { class: "fs-6 mb-0 d-md-none" }
const _hoisted_12 = { class: "fs-6 mb-0 text-muted" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-location-dot me-2" }, null, -1)
const _hoisted_14 = { class: "text-white" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_empty = _resolveComponent("el-empty")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.schedule.length === 0)
      ? (_openBlock(), _createBlock(_component_el_empty, {
          key: 0,
          description: "No calls scheduled"
        }, {
          image: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          false
            ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableDates, (date) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: "nav-item me-1",
                    key: date.date
                  }, [
                    _createElementVNode("a", {
                      onClick: ($event: any) => (_ctx.currentSelectedDate = date.date),
                      class: "nav-link btn d-flex flex-column flex-center rounded-pill min-w-40px me-2 py-4 btn-active-primary"
                    }, [
                      _createElementVNode("span", _hoisted_6, _toDisplayString(date.dayOfWeek), 1),
                      _createElementVNode("span", _hoisted_7, _toDisplayString(date.day), 1)
                    ], 8, _hoisted_5)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.calls, (call) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "d-flex flex-stack mb-4",
              style: {"width":"100%"},
              key: call.callId
            }, [
              _createElementVNode("div", {
                class: "fw-bold ms-5 ms-md-0 cursor-pointer",
                onClick: ($event: any) => (_ctx.viewCall(call)),
                style: {"width":"100%"}
              }, [
                _createElementVNode("div", _hoisted_9, _toDisplayString(call.title), 1),
                _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.getFriendlyDateTime(call.start)) + " - " + _toDisplayString(_ctx.getFriendlyTime(call.end)), 1),
                _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.getShortFriendlyDateTime(call.start)) + " - " + _toDisplayString(_ctx.getFriendlyTime(call.end)), 1),
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createElementVNode("span", _hoisted_14, _toDisplayString(call.venueSpaceName), 1)
                ])
              ], 8, _hoisted_8)
            ]))
          }), 128))
        ]))
  ]))
}